import React from 'react'
import Container from './styles'
import decodeEntities from '../../util/textDecode'

const OutboundLinks = ({ links }) => {
  return (
    <Container>
      <div className="center">
        <ul className="list">
          {links.map(link => (
            <li key={link.data}>
              <small>{link.data}</small>
              <h3>
                <a href={link.url} target="_blank" rel="noreferrer">
                  {decodeEntities(link.titulo)}
                </a>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: link.descricao.replace(/<p class="link-more.*/, ''),
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

export default OutboundLinks
